export default "__VITE_ASSET__Cox68fNI__"